import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DashboardNew from '../component/user/DashboardNew';
import CommandCenter from '../component/user/CommandCenter';
import Sidebar from '../component/Sidebar';
import Topbar from '../component/Topbar';
import SecureGuardCompliance from '../component/user/SecureGuardCompliance';
import SecureGuard from '../component/user/SecureGuard';
import SecureGuardComplianceDetail from '../component/user/SecureGuardComplianceDetail';
import WellArchitectedNew from '../component/waf/WellArchitectedNew';
import CloudMapPage from '../component/user/CloudMapPage';
import CloudMapDiagram from '../components/CloudMap/CloudMapDiagram';
import DefenderScanTable from '../component/user/DefenderScanTable';
import DefenderScanDetail from '../component/user/DefenderScanDetail';
import FineOps from '../component/user/FineOps';
import UpdatePricingPlans from '../component/user/UpdatePricingPlans';
import UpdateConnectedAccount from '../component/user/UpdateConnectedAccount';
import Setting from '../component/user/Setting';

const UserDashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();

  // Map of routes to page titles
  const routeTitles = [
    { path: "/dashboard/home", title: "Dashboard" },
    { path: "/dashboard/cloudmap", title: "Cloud Map" },
    { path: "/dashboard/cloudmap-inventory", title: "CloudMap - Resource Inventory" },
    { path: "/dashboard/cloudmap-diagram", title: "CloudMap - Architecture Diagram" },
    { path: "/dashboard/secureguard", title: "Secure Guard" },
    { path: "/dashboard/secureguard/compliance", title: "Secure Guard Compliance" },
    { path: "/dashboard/secureguard/compliance/:slug", title: "Compliance Details" },
    { path: "/dashboard/well-architected", title: "AWS Well-Architected Framework" },
    { path: "/dashboard/defender-scan", title: "Defender Scan" },
    { path: "/dashboard/defender-scan/details/:slug", title: "Defender Scan Details" },
    { path: "/dashboard/fineops", title: "FinOps" },
    { path: "/dashboard/command-center", title: "Command Center" },
    { path: "/dashboard/billing-detail", title: "Billing Details" },
    { path: "/dashboard/connected-accounts", title: "Connected Accounts" },
    { path: "/dashboard/setting", title: "Tenant Settings" },
  ];

  useEffect(() => {
    const currentPath = location.pathname;

    // Find matching route title or use default
    const matchedRoute = routeTitles.find((route) => {
      const regex = new RegExp(`^${route.path.replace(/:\w+/g, "\\w+")}$`); // Handle dynamic routes
      return regex.test(currentPath);
    });

    document.title = matchedRoute ? matchedRoute.title : "User Portal";
  }, [location, routeTitles]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 768); // Open sidebar only on large screens
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // Initialize sidebar state based on window size
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="dashboard">
      {/* Sidebar */}
      <Sidebar isVisible={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <div
        className="main-content"
        style={{
          marginLeft: isSidebarOpen ? '250px' : '80px', // Adjust dynamically
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div
          style={{
            paddingTop: '0px', // Prevent overlap with Topbar
          }}
        >
          <Routes>
            <Route path="/home" element={<DashboardNew isSidebarOpen={isSidebarOpen} key={location.key} />} />
            <Route path="/cloudmap" element={<CloudMapPage isSidebarOpen={isSidebarOpen} />} />
            <Route path="/cloudmap-diagram" element={<CloudMapDiagram />} />
            <Route path="/secureguard" element={<SecureGuard isSidebarOpen={isSidebarOpen} />} />
            <Route path="/secureguard/compliance" element={<SecureGuardCompliance isSidebarOpen={isSidebarOpen} />} />
            <Route path="/secureguard/compliance/:slug" element={<SecureGuardComplianceDetail isSidebarOpen={isSidebarOpen} />} />
            <Route path="/well-architected" element={<WellArchitectedNew />} />
            <Route path="/defender-scan" element={<DefenderScanTable isSidebarOpen={isSidebarOpen} />} />
            <Route path="/defender-scan/details/:slug" element={<DefenderScanDetail isSidebarOpen={isSidebarOpen} />} />
            <Route path="/fineops" element={<FineOps isSidebarOpen={isSidebarOpen} />} />
            <Route path="/command-center" element={<CommandCenter isSidebarOpen={isSidebarOpen} />} />
            <Route path="/billing-detail" element={<UpdatePricingPlans isSidebarOpen={isSidebarOpen} />} />
            <Route path="/connected-accounts" element={<UpdateConnectedAccount isSidebarOpen={isSidebarOpen} />} />
            <Route path="/setting" element={<Setting isSidebarOpen={isSidebarOpen} />} />
            <Route path="/" element={<Navigate to="/home" />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
